import script from "./SidebarItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarItem.vue?vue&type=style&index=0&id=6eadda54&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eadda54"]])

export default __exports__